import { shouldMockBatchAnswer as e } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerGetResponse as t, createMockBatchAnswerListResponse as n, createMockEvaluationCreationResponse as r } from "./BatchAnswerEvaluations.mocks.js";
import { API as i, Resource as a } from "@coveo/platform-client";
//#region src/resources/batch-answer/evaluations/BatchAnswerEvaluations.resource.ts
var o = 2e3, s = 10, c = class c extends a {
	static {
		this.baseUrl = `/rest/organizations/${i.orgPlaceholder}/answer/v1/evaluations`;
	}
	list(t, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(n(t?.filter)(r?.nbOfMockEntry ?? s, t?.page));
			}, o);
		}) : this.api.get(this.buildPath(`${c.baseUrl}`, t));
	}
	create(t, n) {
		return e(n?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(r(t));
			}, o);
		}) : this.api.post(c.baseUrl, t);
	}
	rename(t, n, i) {
		return e(i?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(r(n));
			}, o);
		}) : this.api.put(`${c.baseUrl}/${t.evaluationId}/name`, n);
	}
	delete(t, n) {
		return e(n?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e();
			}, o);
		}) : this.api.delete(`${c.baseUrl}/${t.evaluationId}`);
	}
	get(n, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(t());
			}, o);
		}) : this.api.get(`${c.baseUrl}/${n.evaluationId}`);
	}
};
//#endregion
export { c as EvaluationResource };

//# sourceMappingURL=BatchAnswerEvaluations.resource.js.map